import React, {Component} from 'react';
import { combineReducers, createStore } from 'redux';
import { connect } from 'react-redux';
import Helmet from "react-helmet";
import Header from '../containers/Header';
import Footer from '../components/Footer';
import Modal from '../components/Modal';

import { getAllStatesSuccess, getAllStatesError } from '../store/actions/GetAllStates';

function mapStateToProps(state) {
   return {
    modal: state.modal.display
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAllStatesSuccess: (json) => {
      dispatch(getAllStatesSuccess(json))
    },
    getAllStatesError: () => {
      dispatch(getAllStatesError())
    }
  }
}

function fetchStateData() {
  const URL = "/api/state";
  return fetch(URL, { method: 'GET'})
     .then( response => Promise.all([response, response.json()]));
}

class AppContainer extends Component {

  componentWillMount() {
    this.fetchStatesWithRedux();
  }

  fetchStatesWithRedux = () => {
    return fetchStateData().then(([response, json]) =>{
        if(response.status === 200){
        this.props.getAllStatesSuccess(json.data);
      }
      else{
        this.props.getAllStatesError();
      }
    })
  }


  render() {

    let modal = null;

    if (this.props.modal) {
      modal = (
        <Modal meta={this.props.route.meta} />
      );
    }

    return (
      <div>
        <Helmet
          meta={[
            { property: "og:site_name", content: 'Site Name Here'},
            { property: "og:type", content: 'website'},
          ]}
        />
        {modal}
        <div className="site_wrapper">
          <Header />
          <div className="content_wrapper">
            {this.props.children}
          </div>
          <Footer />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/views/appContainer.js